import { useTranslation } from 'react-i18next';
import SEO from '../../components/seo/SEO';

export default function TermsOfServicePage() {
  const { t } = useTranslation('terms');

  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <SEO
        title={t('seo.title')}
        description={t('seo.description')}
        canonical="/terms"
        noindex={true}
      />
      <div className="py-12 bg-gradient-to-br from-primary-50 via-white to-purple-50">
        <div className="container-marketing max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary-600 to-purple-600">
              {t('title')}
            </span>
          </h1>
          <p className="text-gray-600">{t('last_updated')}</p>
        </div>
      </div>

      <div className="py-12">
        <div className="container-marketing max-w-4xl prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('agreement.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('agreement.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('license.title')}</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('license.intro')}
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              {t('license.items', { returnObjects: true }).map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('account.title')}</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('account.intro')}
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              {t('account.items', { returnObjects: true }).map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('acceptable_use.title')}</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('acceptable_use.intro')}
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              {t('acceptable_use.items', { returnObjects: true }).map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('subscription.title')}</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('subscription.intro')}
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              {t('subscription.items', { returnObjects: true }).map((item: string, index: number) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('trial.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('trial.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('data_ownership.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('data_ownership.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('availability.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('availability.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('intellectual_property.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('intellectual_property.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('liability.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('liability.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('termination.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('termination.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('changes.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('changes.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('governing_law.title')}</h2>
            <p className="text-gray-700 leading-relaxed">
              {t('governing_law.content')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('contact.title')}</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              {t('contact.intro')}
            </p>
            <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
              <p className="text-gray-700"><strong>{t('contact.email_label')}:</strong> {t('contact.email')}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
